import { Tabs as AntTabs, TabPaneProps } from 'antd';
import React from 'react';

export interface ITabPaneProps extends TabPaneProps {}

/**
 * Tabs make it easy to switch between different views.
 */
export const TabPane: React.FC<ITabPaneProps> = (props) => (
  <AntTabs.TabPane {...props} />
);
